import { useState } from "react";
import { ImpactosAmbientais, ObjSumario, Sumario } from "../../components";
import { Box, Paper } from "@mui/material";
import { List } from "@mui/icons-material";

export const SectionIII = () => {
  const [screen, setScreen] = useState<JSX.Element>(<ImpactosAmbientais />);
  const [showSumario, setShowSumario] = useState(true);

  const itemsSumario: ObjSumario[] = [{
    title: "Avaliação de Impactos Ambientais",
    type: "item",
  }];

  return (
    <Box sx={{
      py: "1em",
      pr: "1em",
      width: `100%`,
      height: `100%`,
      display: "flex",
      flexDirection: "row",
      pl: showSumario ? "1em" : 0,
      position: "relative",
    }}>
      {showSumario && (
        <Box sx={{ width: "25%", height: "100%", display: "flex", flexDirection: "row" }}>
          <Sumario
            items={itemsSumario}
            onSelect={(item) => item.screen && setScreen(item.screen)}
            onClose={() => setShowSumario(false)}
          />
        </Box>
      )}

      {!showSumario && (
        <div
          onClick={() => setShowSumario(true)}
          style={{
            padding: "5px",
            position: 'absolute',
            display: "flex",
            height: "46px",
            width: "46px",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#fff",
            border: "1px solid black",
            borderTopRightRadius: "50%",
            borderBottomRightRadius: "50%",
            boxShadow: "10px",
            top: 5,
            left: 0,
            zIndex: 10000,
          }}
        >
          <List />
        </div>
      )}

      <Paper elevation={0} sx={{
        flex: 1,
        width: "100%",
        height: "100%",
        textAlign: "justify",
        p: "15px",
      }}>
        {screen}
      </Paper>
    </Box>
  );
};